import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import moment from 'moment';

import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import localization from '../../../localization';
import parentPaths from '../../../services/paths';

export const ScheduledPricesTable = ({ scheduledPrices }) => {
  const history = useHistory();

  const makeCopy = (value) => {
    navigator.clipboard
      .writeText(value)
      .then(() => toast(localization.t('general.itemHasBeenCopied')));
  };

  return (
    <>
      <Typography variant='h6'>Date range</Typography>
      <Typography>
        The following table represents values set with the new price service, you can click on each
        ID to navigate and mange them.
      </Typography>
      <Box mt={3} px={2}></Box>

      <Box mt={3} px={2} className='product-prices'>
        <TableContainer component={Paper}>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow style={{ background: '#eee' }}>
                <TableCell>Price</TableCell>
                <TableCell align='center'>Marketing Campaign</TableCell>
                <TableCell align='center'>Product Reco Id</TableCell>
                <TableCell align='center'>Starts at</TableCell>
                <TableCell align='center'>Ends at</TableCell>
                <TableCell align='center'>Country</TableCell>
                <TableCell align='center'>Currency</TableCell>
                <TableCell align='center'>Value</TableCell>
                <TableCell align='center'>MSRP</TableCell>
                <TableCell align='center'>Upsell price</TableCell>
                <TableCell align='center'>Cross-sell price</TableCell>
                <TableCell align='center'>VAT included</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {scheduledPrices.map((price, index) => (
                <TableRow
                  key={price?.id || index}
                  className={!price?.endDate || moment().isBefore(price?.endDate) ? '' : 'outdated'}
                >
                  <TableCell component='th' scope='row'>
                    <Box className='price'>
                      <Typography variant='subtitle1'>
                        <span
                          className='price-value'
                          onClick={() =>
                            history.push({
                              pathname: `${parentPaths.pricemodels.pricesTab}/${price?.id}`,
                              state: {
                                isPriceHistoryId: price?.originalPriceId,
                              },
                            })
                          }
                        >
                          {price?.id}
                        </span>
                      </Typography>
                      <FileCopyIcon onClick={() => makeCopy(price?.id)} color='secondary' />
                    </Box>
                  </TableCell>
                  <TableCell align='center'>
                    <Box className='price'>
                      <Typography variant='subtitle1'>
                        {price?.marketingCampaignId || '-'}
                      </Typography>
                      {price?.marketingCampaignId && (
                        <FileCopyIcon
                          onClick={() => makeCopy(price?.marketingCampaignId)}
                          color='secondary'
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align='center'>
                    <Box className='price'>
                      <Typography variant='subtitle1' sx={{ width: '100%' }}>
                        {price?.productRecoId || '-'}
                      </Typography>
                      {price?.productRecoId && (
                        <FileCopyIcon
                          onClick={() => makeCopy(price.productRecoId)}
                          color='secondary'
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align='center'>
                    {price?.startDate ? moment(price.startDate).format('ll') : '-'}
                  </TableCell>
                  <TableCell align='center'>
                    {price?.endDate ? moment(price.endDate).format('ll') : '-'}
                  </TableCell>
                  <TableCell align='center'>{price?.country || 'default'}</TableCell>
                  <TableCell align='center'>{price?.currency || '-'}</TableCell>
                  <TableCell align='center'>{price?.value || '-'}</TableCell>
                  <TableCell align='center'>{price?.msrp || '-'}</TableCell>
                  <TableCell align='center'>{price?.upSell || '-'}</TableCell>
                  <TableCell align='center'>{price?.crossSell || '-'}</TableCell>
                  <TableCell align='center'>{price?.vatIncluded ? 'YES' : 'NO'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Link
          to={{
            pathname: `${parentPaths.pricemodels.pricesTab}/add`,
            state: {
              scheduledPriceCustomerId: scheduledPrices[0]?.customerId,
              scheduledProductId: scheduledPrices[0]?.productId,
            },
          }}
        >
          <Button variant='contained' sx={{ marginTop: 4 }}>
            {localization.t('general.add')}
          </Button>
        </Link>
      </Box>
    </>
  );
};
